// extracted by mini-css-extract-plugin
export var quantityInput = "_ni-0";